import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
  RouterProvider,
} from "react-router-dom";
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import Startseite from './Routes/Startseite';
import Trainingszeiten from './Routes/Trainingszeiten';
import {Admin} from './Routes/Admin';
import {Verein} from './Routes/Verein';
import MitgliedWerden from './Routes/MitgliedWerden';
import Impressum from './Komponenten/Impressum';
import BackgroundImage from "..\\src\\IMG_20230527_165621.jpg";

const queryClient = new QueryClient();


const router =  createBrowserRouter(
  createRoutesFromElements(
    <>
      <Route path='/Trainingszeiten' element={<Trainingszeiten/>}></Route>
      <Route path='/Verein' element={<Verein />}></Route>
      <Route path='/Admin' element={<Admin/>}></Route>
      <Route path='/MitgliedWerden' element={<MitgliedWerden />}></Route>
      <Route path="/index.html" element={<Startseite/>} />
      <Route path="/" element={<Startseite/>} />
    </>
  )
)

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <div style={{
          backgroundImage: `url(${BackgroundImage})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundAttachment: 'fixed',
          width: '100vw',
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column'
        }}>
        <div style={{ flex: 1 }}>
          <RouterProvider router={router}></RouterProvider>
        </div>
        <Impressum />
      </div>
    </QueryClientProvider>
  </React.StrictMode>
);
